export default "/images/chev-back.svg?155c467bd5dbbdd95db220b401ab2e64";